export default __webpack_public_path__ + "static/media/bpm-gray.41b558eb.svg";